<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.company_profile.company') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'company-profile-create' })"
            >
              {{ $t('addministration.company_profile.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.company_profile.search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.company_name_kh }}</td>
          <td>{{ record.company_name_en }}</td>
          <td>{{ record.company_phone }}</td>
          <td>{{ record.company_email }}</td>
          <td>{{ record.company_website }}</td>
          <td>
            {{ $store.getters.limitStringShow(record.company_address, 30) }}
          </td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'company-profile-edit',
                params: { id: record.company_id }
              }"
              v-tooltip="$t('addministration.company_profile.edit')"
              class="mr-3"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a
              href="#"
              v-tooltip="$t('addministration.company_profile.delete')"
              class="text-danger"
              @click.prevent="destroy(record.company_id)"
            >
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'company-profile',
  data() {
    return {
      loading: false,
      columns: [
        {
          name: this.$t('addministration.company_profile.name_kh'),
          style: 'width: 13%'
        },
        {
          name: this.$t('addministration.company_profile.name_en'),
          style: 'width: 13%'
        },
        {
          name: this.$t('addministration.company_profile.phone_number'),
          style: 'width: 15%'
        },
        {
          name: this.$t('addministration.company_profile.email'),
          style: 'width: 8%'
        },
        {
          name: this.$t('addministration.company_profile.website'),
          style: 'width: 8%'
        },
        { name: this.$t('addministration.company_profile.address') },
        {
          name: this.$t('addministration.company_profile.action'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('companyProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.companyProfile.search
      },
      set(newValue) {
        this.$store.commit('companyProfile/SET_SEARCH', newValue)
        this.$store.commit('companyProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('companyProfile/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(id) {
      if (
        await this.$confirmModal.danger(
          this.$t('addministration.company_profile.are_you_sure_to_delete')
        )
      ) {
        this.$store
          .dispatch('companyProfile/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'company-profile-create') {
      this.$store.commit('companyProfile/RESET_STATE')
    }
    next()
  }
}
</script>
